<template lang="pug">
  div
    v-row(no-gutters).my-4
      h3 Breakdown
        v-btn(
          icon
          x-small
          top
          @click.stop="showActions = true"
          color="primary"
          v-if="isNew"
        )
          v-icon mdi-plus
      v-spacer
      v-btn(
        depressed
        text
        color="error"
        small
        v-if="showActions"
        @click.stop="cancel"
        :disabled="loading"
      ).plain.mr-2 Cancel
      v-btn(
        depressed
        color="primary"
        small
        v-if="showActions"
        @click.stop="addToList()"
        :disabled="!valid || loading"
      ).plain Add
    v-form(
      ref="form"
      v-model="valid"
    )
      v-row(
        no-gutters
        v-if="showActions"
      )
        v-col(cols="6")
          v-text-field(
            label="Item Name"
            v-model="fundingItemName"
            clearable
            outlined
            :rules="[v => !!v || 'Item name is required']"
            :disabled="loading"
          ).pr-2
        v-col(cols="6")
          v-tooltip(
            light
            top
            open-delay="100"
          )
            template(v-slot:activator="{ on }")
              v-text-field(
                label="Amount"
                v-model.number="fundingItemAmount"
                @blur="setRoundedAmount()"
                placeholder="5"
                clearable
                outlined
                prefix="PHP"
                type="number"
                :rules="[v => !!v || 'Amount is required', v => v >= 5 || 'Funds should not be less than 5']"
                :disabled="loading"
                :min="5"
                v-on="on"
              ).pl-2
            small Amount will be rounded off to the nearest 5
    v-chip(
      v-for="(item, i) in funding.items"
      :key="i"
      color="primary"
      @click:close="removeFromList(i)"
      :close="isNew"
    ).mr-4.mb-2 {{item.name}}&nbsp;#[money(:value="item.amount")]
</template>

<script>
import Money from '@/components/commons/Money';
export default {
  components: {
    Money
  },
  props: {
    beneficiary: {
      type: Object
    },
    funding: {
      type: Object,
      default: () => ({ items: [] })
    },
    isNew: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    beneficiary () {
      this.localBeneficiary = this.beneficiary;
    },
    funding () {
      this.localFunding = this.funding;
    }
  },
  data () {
    return {
      localBeneficiary: {},
      localFunding: {},
      fundingItems: [],
      fundingItemName: '',
      fundingItemAmount: 5,
      showActions: false,
      valid: false,
      fundingTotal: 0,
      loading: false
    };
  },
  methods: {
    setRoundedAmount () {
      let quotient = Math.floor(this.fundingItemAmount / 5);
      this.fundingItemAmount = quotient * 5;
    },
    addToList () {
      this.funding.items.push({
        name: this.fundingItemName,
        amount: this.fundingItemAmount
      });
      this.fundingTotal += this.fundingItemAmount;
      this.cancel();
      this.emit();
    },
    removeFromList (index) {
      this.fundingTotal -= this.funding.items[index].amount;
      this.funding.items.splice(index, 1);
      this.emit();
    },
    emit () {
      this.$emit(
        'listChange',
        {
          fundingItems: this.funding.items,
          fundingTotal: this.fundingTotal
        }
      );
    },
    cancel () {
      this.fundingItemName = '';
      this.fundingItemAmount = 5;
      this.showActions = false;
      this.$refs.form.resetValidation();
    }
  }
};
</script>